import styled, { keyframes } from 'styled-components';
import { SummaryPlayEventDescription, SummaryPlayEventsWrapper } from '../Play/play/SummaryPlayEvents.style';
import { PlayPitchWrapper } from '../Play/play/PlayPitches.style';
import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';
import { motion } from 'framer-motion';
import playTypeMap from '../DynamicFieldView/utils/playTypeMap';
const { PITCH, RESULT } = playTypeMap;

const {
    MD
} = GDBREAKPOINTS;

const ChipAnimSlide = keyframes`
  12% {
    transform: translateY(0);
    opacity: 0;
  }
  15% {
    opacity: 1;
  }
  97% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(calc(100% + 10px));
    opacity: 1;
  }
`;

const ChipAnimFade = keyframes`
  12% {
    transform: translateY(0);
    opacity: 0;
  }
  15% {
    opacity: 1;
  }
  97% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(0);
  }
`;

export const ChipContainer = styled.div.attrs(({ $timer }) => {
    return {
        style: {
            animationDuration: $timer
        }
    };
})`
    overflow: hidden;
    width: 100%;
    padding: 16px 0px;
    font-family: var(--gameday-primary-font);
    position: relative;

    .chipfeed-ad {
      position: absolute;
      width: 114px;
      height: 48px;
      top: 16px;
      right: 0;
      top: 20px;
      right: 16px;
      border-radius: 0px 5px 0px 0px;
      animation-timing-function: ease-out;
      animation-name: ${ChipAnimSlide};
      transform: translateY(60px);
      opacity: 0;
      @media (min-width: ${MD}) {
          animation-timing-function: ease-out;
          animation-name: ${ChipAnimFade};
      }
    }

`;

export const DFVChipContainer = styled(ChipContainer)`
    flex: 1;
    position: relative;
    padding: 0 0 var(--gameday-section-padding-sm) 0;
    
    ${({ $playType }) => {
      if ($playType === PITCH || $playType === RESULT) {
          return `
              align-self: end;
              height: auto;
              max-height: 100px;
              overflow: hidden;
          `;
      }
    }};
    
`;

export const ChipWrapper = styled.div.attrs(({ $timer }) => {
    return {
        style: {
            animationDuration: $timer
        }
    };
})`
    background-color: var(--gameday-background-color);
    box-sizing: border-box;
    border-radius: var(--gameday-border-radius);
    padding: 8px;
    opacity: 0;
    width: 100%;
    animation-timing-function: ease-out;
    animation-name: ${ChipAnimSlide};
    transform: translateY(60px);
    box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.24);

    @media (min-width: ${MD}) { 
      animation-timing-function: ease-out;
      animation-name: ${ChipAnimFade};
    }

    ${SummaryPlayEventsWrapper} {
      padding-left: 5px;    
      >div {
        color: var(--gameday-primary-font-color);
      }
    }
`;

export const ChipWrapperFlex = styled(ChipWrapper)`
    
    ${SummaryPlayEventsWrapper} {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    ${SummaryPlayEventDescription} {
      padding-top: 0px;
    }
`;

export const DfvChipWrapper = styled.div`
  background-color: var(--gameday-background-color);
  box-sizing: border-box;
  border-radius: var(--gameday-border-radius);
  padding: 8px;
  opacity: 0;
  width: 100%;
  transform: translateY(60px);
  background-color: var(--gameday-dfv-batterview-bg-color);
  font-size: 14px;
  line-height: 14px;
  color: var(--gameday-dfv-batterview-text-color);
  box-shadow: 0px 10px 32px 0px #00000014;

  ${SummaryPlayEventsWrapper} {
    padding-left: 5px;
    font-weight: var(--gameday-card-title-font-weight);
    >div {
      color: var(--gameday-dfv-batterview-text-color);
    }
  }

  ${SummaryPlayEventDescription} {
    font-weight: 500;
    font-size: 14px;
  }

  ${PlayPitchWrapper} {
    color: var(--gameday-dfv-batterview-text-color);
  }
`;

export const MotionDfvChipWrapper = motion(DfvChipWrapper);
